import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import { InlineGrid, InlineGridField } from '@components/form';

import { EmployeesFormIdentificationsForm } from '@modules/employees/EmployeesFormIdentificationsForm';
import { identificationsGridColumns } from '@modules/employees/_employeesColumns';

const View: React.SFC<any> = () => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col md={12}>
          <h4>Doklady totožnosti</h4>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <InlineGridField
            component={InlineGrid}
            name="identifications"
            Form={EmployeesFormIdentificationsForm}
            columns={identificationsGridColumns}
            showCheckboxes={true}
            deleting={true}
          />
        </Col>
      </Row>
    </Grid>

    <Divider />
  </div>
);

export const EmployeesFormIdentifications = View;



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesFormIdentifications.tsx